'use client';

import classNames from 'classnames';
import { Menu, MenuButton, MenuItems, MenuItem } from '@headlessui/react';

// Types
import { DropdownProps } from '../../types/display/dropdown';

// Components
import { Icon, Typography } from '@preventx/oxygen';

export const Dropdown = ({
  icon,
  label,
  onOpen,
  options,
  ariaLabel,
}: DropdownProps) => (
  <Menu as="div" className="dropdown">
    {({ open }) => {
      if (open && onOpen) {
        onOpen();
      }

      return (
        <>
          <MenuButton
            as="button"
            aria-label={ariaLabel}
            data-type="icon-button"
            className="button dropdown__control"
          >
            {label && <Typography component="span">{label}</Typography>}

            {icon && <Icon icon={icon} />}
          </MenuButton>

          <MenuItems
            as="ul"
            anchor="bottom start"
            className={classNames({
              'dropdown__panel active stack-nav m-0': open,
            })}
          >
            {options.map(({ id, children }) => (
              <MenuItem key={id}>{children}</MenuItem>
            ))}
          </MenuItems>
        </>
      );
    }}
  </Menu>
);
